import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import SubPageHeader from '../common/SubPageHeader';
import SubPageFooter from '../common/SubPageFooter';

const AdminLayout = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <div className="min-h-screen flex flex-col bg-[#f8fafc]">
            {/* 1. Header is Always Top & Fixed */}
            <AdminNavbar
                setIsMobileMenuOpen={setIsMobileMenuOpen}
            />

            <div className="flex flex-1 pt-[64px] relative">
                {/* 2. Sidebar is Fixed below Navbar */}
                {isMobileMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black/50 z-[400] md:hidden"
                        onClick={() => setIsMobileMenuOpen(false)}
                    />
                )}
                <AdminSidebar
                    isHovered={isHovered}
                    setIsHovered={setIsHovered}
                    isMobileMenuOpen={isMobileMenuOpen}
                    setIsMobileMenuOpen={setIsMobileMenuOpen}
                />

                {/* 3. Main Area shifts according to isHovered */}
                <div
                    className={`flex-1 flex flex-col transition-all duration-300 ${
                        isHovered ? 'md:ml-64' : 'md:ml-16'
                    }`}
                >
                    
                    {/* Banner from Image 1 / SubPageHeader */}
                    <SubPageHeader title="Admin Portal" />
                    
                    {/* Content Section */}
                    {/* <main className="flex-grow min-h-screen px-3 md:px-10 pb-10 relative"> */}
                    <main className="flex-grow
                    min-h-screen
                    w-full
                    max-w-full
                    overflow-x-hidden
                    px-0
                    md:px-6
                    py-2">
                        <div className="w-full
                        max-w-[1600px]
                        mx-auto
                        animate-fadeIn
                        overflow-x-hidden">
                            <Outlet />
                        </div>
                    </main>

                    <SubPageFooter />
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;